<template lang="pug">
  .xingjiang-rights
    .header
      img(src="../../../public/images/xinjiang/20Y30G2.png")
    .main
      el-form
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入新疆移动手机号")
        el-form-item
          .verifycode
            .txt-verfiycode
              input(type="text", v-model="form.verifyCode", placeholder="请输入验证码", maxlength="6")
            .btn-verifycode
              button(type="button", :disabled="leftSendTime > 0", @click="sendVerifyCode")
                span(v-if="leftSendTime <= 0") 获取验证码
                span(v-else) {{leftSendTime}}秒后重试
        el-form-item
          img.img-button(src="../../../public/images/xinjiang/button.png", @click="handleSubmit")
    //- .processing
    //-   ol
    //-     li
    //-       .title 支付成功
    //-       .icon
    //-         img(src="../../../public/images/xinjiang/zhifu.png")
    //-     li
    //-       .title
    //-         div 前往公众号
    //-         div “冰蓝流量”
    //-       .icon
    //-         img(src="../../../public/images/xinjiang/wx.png")
    //-     li
    //-       .title 领取权益
    //-       .icon
    //-         img(src="../../../public/images/xinjiang/quanyi.png")
    .btn-feedback
      a(href="https://wj.qq.com/s2/7374700/78b6/") 问题反馈
    .btn-notice(@click="noticeVisible = true") 活动规则
    el-dialog(:visible.sync="noticeVisible", title="- 活动规则 -", width="96%")
      .content
        ul
          li(v-for="(notice, index) in notices", :key="index")
            .num {{index + 1}}.
            p.content {{notice}}
    el-dialog(:visible.sync="toPayVisible", title="订单已创建", width="70%")
      ul.confirmpay-btns
        li
          a.link-pay(:href="payUrl", @click="toPay", target="_blank") 去支付
    el-dialog(:visible.sync="confirmPayVisible", title="支付确认", width="70%")
      ul.confirmpay-btns
        li
          el-button.btn-confirm(type="primary", @click="confirmPay") 已完成支付
        li
          el-button.btn-confirm(type="warning", @click="handleSubmit") 支付未完成？重试一下
</template>

<script>
export default {
  data() {
    return {
      leftSendTime: 0,
      noticeVisible: false,
      confirmPayVisible: false,
      toPayVisible: false,
      notices: [
        '此活动仅限新疆移动客户参与办理。',
        '权益说明：客户一次性支付20元后，即可享受30GB国内流量、10张*3元话费减免权益、9.9元享视频会员权益、爱奇艺会员最低1元购买、限时领取移动花卡宝藏版、最高66元的美团外卖红包共6大权益，用户支付成功后，可关注“冰蓝流量”微信公众号，回复“新疆移动”领取相关权益。',
        '30GB通用流量权益：包含2个5GB7天流量包（分2个自然月领取）+1个3GB流量月包（有效期6个月，每个自然月含3GB流量，需在办理会员后的2个自然月内领取）以及2个1GB流量日包（分2个自然月领取，一个月领取1次），以上流量包均需在办理会员后的2个自然月内领取完毕，过期视为自动放弃。',
        '10张*3元话费减免权益，可在冰蓝流量公众号充值100元话费时直接使用，仅需支付97元即可获得100元话费。',
        '9.9元享视频会员权益：可办理9.9元咪咕视频会员流量尊享包，每月需支付9.9元话费，即可享受咕视频钻石会员权益+100分钟国内语音分钟+ 2G国内通用流量+30G咪咕视频定向流量，资费长期有效，协议期12个月，协议期内不可取消。',
        '爱奇艺会员最低1元购买权益：最低支付1元购买爱奇艺月度会员。',
        '限时领取移动花卡宝藏版权益：用户可免费领取1张移动花卡宝藏卡，激活后，月套餐费19元/月，首月免月租，套餐内含30G专属流量，可在100+热门APP使用，套外流量超便宜1元1GB；语音只需0.1元/分钟， 加3个亲情号4人互打全国免费；还可享受充值抽奖活动，即首充50元，最高可抽取1000元话费，100%中奖。',
        '最高66元的美团外卖红包权益：每天可通过冰蓝流量公众号权益页面，领取最高66元的美团外卖红包。',
        '6大权益需关注“冰蓝流量”微信公众号，回复“新疆移动”领取，权益领取及使用规则详见权益领取页面说明。',
        '注意事项：请在购买时务必填写正确的需充值的手机号码及短信验证码（输入手机号码如果不是新疆移动的号码或者输入号码及验证码错误，无法办理成功），本产品为系统自动办理，人工无法手动取消办理或者退款，敬请谅解。'
      ],
      form: {
        mobile: '',
        verifyCode: '',
        carrierId: 13,
        userId: '',
        goodsCode: 'WXH5PAY2009280001'
      },
      payUrl: '',
      channel: 'TUIA'
    }
  },
  methods: {
    sendVerifyCode() {
      if (this.leftSendTime > 0) {
        return;
      }
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.OrderService
        .sendVerifyCode({
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.form.goodsCode
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    handleSubmit() {
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      this.addMobilePackage()
    },
    toPay() {
      this.toPayVisible = false
      this.confirmPayVisible = true
    },
    confirmPay() {
      let _loading = this.$loading({
        lock: true,
        text: '正在验证并创建订单...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.OrderService
        .queryPayOrder({
          reqNo: this.reqNo,
          mobile: this.form.mobile
        })
        .then(res => {
          if (res.data.success) {
            if (res.data.sub_data.trade_state.toUpperCase() === 'SUCCESS') {
              this.$router.push({
                name: 'xjActivitySuccess'
              })
            } else {
              this.$message({
                type: 'warning',
                message: res.data.sub_data.trade_state_desc
              })
            }
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '查询失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      // eslint-disable-next-line
      let _queryStr = location.search.replace(/^\?/, '') + location.hash.replace(/^\#/, '&')
      let _oid = ''
      if (_queryStr) {
        let _querys = _queryStr.split('&')
        _querys.forEach(item => {
          // eslint-disable-next-line
          if (/^a\_oId\=/.test(item)) {
            _oid = item.split('=')[1]
          }
        })
      }
      let _formData = {
        mobile: this.form.mobile,
        goodsCode: this.form.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel,
        channelOrderNo: _oid
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在验证并创建订单...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.OrderService
        .createActPayOrder(_formData)
        .then(res => {
          if (res.data.success) {
            // this.$message({
            //   type: 'success',
            //   message: '订单创建完成，正在前往支付...'
            // })
            // 此处不用等待支付，直接记录转化
            if (window.countLog) {
              window.countLog.ready(function() {
                window.countLog.init(function() { 
                }, {
                  isCopy: 0,
                  pageType: 0 
                })
              })
            }
            this.reqNo = res.data.sub_data.req_no
            // let _redirect_url = 'https://vxpage.niceblu.com/normal.html#/xinjiang/activitysuccess'
            // location.href = res.data.sub_data.pay_url
            this.toPayVisible = true
            this.payUrl = res.data.sub_data.pay_url
            // window.open(res.data.sub_data.pay_url)
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.xingjiang-rights{
  background-color: #061540;
  padding-bottom: 2rem;
  .header{
    img{
      width: 100%;
    }
  }
  .main{
    width: 80%;
    margin: 0 auto;
    margin-top: -13.5rem;
    padding: 1rem;
    border-radius: 6px;
    .button-item{
      background-color: #ff8324;
      color: #fff;
      width: 100%;
      text-align: center;
      border: 0;
    }
    .verify-btn{
      background-color: #409EFF;
      color: #fff;
    }
    .img-button{
      width: 100%;
      margin-top: -.8rem;
    }
    .verifycode{
      display: flex;
      height: 40px;
      line-height: 40px;
    }
    .btn-verifycode{
      flex: .7;
      button{
        background-color: #fff;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        width: 100%;
        border: 0;
        outline: 0;
        padding: 0;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
    .txt-verfiycode{
      width: 100%;
      flex: 1.3;
      input{
        background-color: #fff;
        // border: 1px solid #DCDFE6;
        border: 0;
        border-right: 0;
        padding: 0 15px;
        outline: 0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        color: #606266;
        border-radius: 4px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right-color: #fff;
        box-sizing: border-box;
        &::-webkit-input-placeholder{
          color: #b9b9b9;
          font-size: 14px;
        }
      }
    }
  }
  .content{
    ul{
      li{
        clear: both;
        overflow: hidden;
        font-size: .8rem;
        color: #4A9F94;
        margin-bottom: .2rem;
        .num{
          float: left;
          width: 1.4rem;
          line-height: 1.2rem;
        }
        .content{
          line-height: 1.2rem;
          margin-left: 1.3rem;

        }
      }
    }
  }
  .notice{
    width: 86%;
    padding: 1rem;
    margin: 0 auto;
    margin-top: 3rem;
    background-color: #fff;
    box-shadow: 0 0 3px #a3a3a3;
    border-radius: 6px;
    .title{
      text-align: center;
    }
    
  }
}
.btn-notice{
  position: absolute;
  right: 0;
  top: 2rem;
  word-wrap: break-word;
  width: .6rem;
  font-size: .6rem;
  color: #f3f3f3;
  background-color: rgba(33, 33, 33, .4);
  padding: .5rem;
}
.processing{
  width: 90%;
  background-color: #ffffff;
  margin: 0 auto;
  margin-top: 2rem;
  border-radius: 6px;
  padding: .8rem 0;
  box-shadow: 0 0 12px #333;
  ol{
    display: flex;
    li{
      flex: 1;
      text-align: center;
      position: relative;
      .title{
        color: #47c1ac;
        margin-bottom: 1rem;
        height: 2.5rem;
      }
      img{
        width: 48px;
        height: 48px;
      }
      &::after{
        background: url('../../../public/images/xinjiang/right.png');
        background-size: 32px 32px;
        content: "";
        width: 32px;
        height: 32px;
        position: absolute;
        right: -0.9rem;
        top: 3.9rem;
      }
      &:last-child{
        &::after{
          width: 0px;
          height: 0px;
          display: none;
        }
      }
    }
  }
}
.btn-confirm{
  width: 100%;
}
.confirmpay-btns{
  li{
    margin-bottom: 2rem;
  }
}
.link-pay{
  display: block;
  text-align: center;
  width: 100%;
  text-decoration: none;
  background-color: rgb(197, 34, 34);
  color: #fff;
  padding: .6rem 0;
  border-radius: 12px;
  font-size: 1.2rem;
}
.btn-feedback{
  position: absolute;
  right: 0;
  top: 9rem;
  word-wrap: break-word;
  width: .6rem;
  font-size: .6rem;
  background-color: rgba(33, 33, 33, .4);
  padding: .5rem;
  a{
    color: #f3f3f3;
    text-decoration: none;
  }
}
</style>